import React from "react";
import "./Community.css";
import { FaUsers, FaHandshake, FaGlobe } from "react-icons/fa"; // Importing icons

const CommunitySection = () => {
  return (
    <section className="community-container">
      <h1 className="community-header">Help You Find Your Community in Bengaluru</h1>
     <br/>
      <div className="community-boxes">
        <div className="community-box">
          <FaUsers className="community-icon" />
          <h3>Connect Community and Cooperate</h3>
          <p>Expand your family in Bangalore.</p>
        </div>
        <div className="community-box">
          <FaHandshake className="community-icon" />
          <h3>Build Family and Business Relationships</h3>
          <p>Know each other and support them in their journey.</p>
        </div>
        <div className="community-box">
          <FaGlobe className="community-icon" />
          <h3>Promote and Motivate Our Culture & Customs</h3>
          <p>Target customers in your community or worldwide with our all-in-one marketing solution.</p>
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;
